/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-use-before-define */
import React from 'react'

const PlusIconWmo = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="#3E3E47"
      d="M22.1673 15.1667H15.1673V22.1667H12.834V15.1667H5.83398V12.8334H12.834V5.83337H15.1673V12.8334H22.1673V15.1667Z"
    />
  </svg>
)

export default PlusIconWmo
